"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockLinkedinData = exports.mockLessonData = exports.mockLearnData = void 0;
exports.mockLearnData = {
    assignedContent: {
        courses: [
            {
                uuid: 'a5bdd355-a699-4668-8ff0-36b3215e6191',
                name: 'ruby',
                displayName: 'Ruby on Rails Ruby on Rails Ruby on Rails Ruby on Rails Ruby on Rails',
                description: 'Learn about the OWASP Top 10 covering all aspects including the vulnerability, why it happens, exploits and defenses. Learn about the OWASP Top 10 covering all aspects including the vulnerability, why it happens, exploits and defenses.',
                iconUrl: 'https://content.devcodebashing.com/courses-assets/ruby.png',
                isPrimary: true,
                tagline: 'Ruby on Rails tagline',
                completionPercentage: 0,
                nextLessonUrl: '/courses/ruby/lessons/sql_injection',
                numberOfLessons: 6,
            },
        ],
        lessons: [
            {
                id: 250,
                uuid: '6167f2688df887b62376a6a0',
                name: 'sql_injection',
                displayName: 'SQL Injection',
                duration: '5-8',
                description: 'lesson very very very very very very very very very long description ',
                iconUrl: 'https://content.codebashing.com/courses-assets/sql_injection.png',
                isSystemCourse: false,
                position: 1,
                status: 'start',
                systemCourseDisplayName: 'Ruby on Rails',
                url: '/courses/ruby/lessons/sql_injection',
                potentialPoints: 1000,
                doneRecently: false,
                earnedPoints: 100,
            },
            {
                id: 250,
                uuid: '6167f2688df887b62376a6a0',
                name: 'sql_injection',
                displayName: 'SQL Injection',
                duration: '5-8',
                description: 'lesson very very very very very very very very very long description ',
                iconUrl: 'https://content.codebashing.com/courses-assets/sql_injection.png',
                isSystemCourse: false,
                position: 1,
                status: 'start',
                systemCourseDisplayName: 'Ruby on Rails',
                url: '/courses/ruby/lessons/sql_injection',
                potentialPoints: 1000,
                doneRecently: false,
                earnedPoints: 100,
            },
            {
                id: 250,
                uuid: '6167f2688df887b62376a6a0',
                name: 'sql_injection',
                displayName: 'SQL Injection',
                duration: '5-8',
                description: 'lesson very very very very very very very very very long description ',
                isSystemCourse: false,
                position: 1,
                status: 'start',
                systemCourseDisplayName: 'Ruby on Rails',
                url: '/courses/ruby/lessons/sql_injection',
                potentialPoints: 1000,
                doneRecently: false,
                earnedPoints: 100,
            },
            {
                id: 250,
                uuid: '6167f2688df887b62376a6a0',
                name: 'sql_injection',
                displayName: 'SQL Injection',
                duration: '5-8',
                description: 'lesson very very very very very very very very very long description ',
                isSystemCourse: false,
                position: 1,
                status: 'start',
                systemCourseDisplayName: 'Ruby on Rails',
                url: '/courses/ruby/lessons/sql_injection',
                potentialPoints: 1000,
                doneRecently: false,
                earnedPoints: 100,
            },
            {
                id: 250,
                uuid: '6167f2688df887b62376a6a0',
                name: 'sql_injection',
                displayName: 'SQL Injection',
                description: 'lesson very very very very very very very very very long description ',
                duration: '5-8',
                iconUrl: 'https://content.codebashing.com/courses-assets/sql_injection.png',
                isSystemCourse: false,
                position: 1,
                status: 'completed',
                cwe: 'CWE-89',
                owasp: 'A3: Injection',
                sans: 'SANS-#1',
                systemCourseDisplayName: 'Ruby on Rails',
                url: '/courses/ruby/lessons/sql_injection',
                potentialPoints: 1000,
                doneRecently: false,
                earnedPoints: 100,
            },
            {
                id: 250,
                uuid: '6167f2688df887b62376a6a0',
                name: 'sql_injection',
                displayName: 'SQL Injection',
                description: 'lesson very very very very very very very very very long description ',
                duration: '5-8',
                iconUrl: 'https://content.codebashing.com/courses-assets/sql_injection.png',
                isSystemCourse: false,
                position: 1,
                status: 'completed',
                cwe: 'CWE-89',
                owasp: 'A3: Injection',
                sans: 'SANS-#1',
                systemCourseDisplayName: 'Ruby on Rails',
                url: '/courses/ruby/lessons/sql_injection',
                potentialPoints: 1000,
                doneRecently: false,
                earnedPoints: 100,
            },
        ],
    },
    otherCourses: [
        {
            uuid: 'a5bdd355-a699-4668-8ff0-36b3215e6191',
            name: 'ruby',
            displayName: 'Ruby on Java',
            tagline: 'Ruby on Java tagline',
            description: 'Learn about the OWASP Top 10 covering all aspects including the vulnerability, why it happens, exploits and defenses.',
            iconUrl: 'https://content.devcodebashing.com/courses-assets/ruby.png',
            isPrimary: true,
            completionPercentage: 100,
            nextLessonUrl: '/courses/ruby/lessons/sql_injection',
            numberOfLessons: 6,
            activeOnLean: true,
            quizStatus: 'not_completed',
        },
        {
            uuid: 'a5bdd355-a699-4668-8ff0-36b3215e6191',
            name: 'ruby',
            displayName: 'Ruby on Java',
            tagline: 'Ruby on Java tagline',
            description: 'Learn about the OWASP Top 10 covering all aspects including the vulnerability, why it happens, exploits and defenses.',
            iconUrl: 'https://content.devcodebashing.com/courses-assets/ruby.png',
            isPrimary: true,
            completionPercentage: 100,
            nextLessonUrl: '/courses/ruby/lessons/sql_injection',
            numberOfLessons: 6,
            activeOnLean: true,
            quizStatus: 'completed',
        },
        {
            uuid: 'a5bdd355-a699-4668-8ff0-36b3215e6191',
            name: 'ruby',
            displayName: 'Ruby on Java',
            description: 'Learn about the OWASP Top 10 covering all aspects including the vulnerability, why it happens, exploits and defenses.',
            tagline: 'Ruby on Java tagline',
            iconUrl: 'https://content.devcodebashing.com/courses-assets/ruby.png',
            isPrimary: true,
            completionPercentage: 0,
            nextLessonUrl: '/courses/ruby/lessons/sql_injection',
            numberOfLessons: 6,
            activeOnLean: false,
        },
        {
            uuid: 'a5bdd355-a699-4668-8ff0-36b3215e6191',
            name: 'ruby',
            displayName: 'Ruby on Java',
            tagline: 'Ruby on Java tagline',
            description: 'Learn about the OWASP Top 10 covering all aspects including the vulnerability, why it happens, exploits and defenses.',
            isPrimary: true,
            completionPercentage: 0,
            nextLessonUrl: '/courses/ruby/lessons/sql_injection',
            numberOfLessons: 6,
            activeOnLean: false,
        },
    ],
};
exports.mockLessonData = {
    lessonUuid: 'a5bdd355-a699-4668-8ff0-36b3215e6191',
    lessonDisplayName: 'SQL Injection',
    courseDisplayName: 'Java',
    lessonIconUrl: 'https://content.devcodebashing.com/courses-assets/java.png',
    containerName: 'Java',
    containerUrl: '/app/course?courseUuid=23577758-4095-4478-abf3-dd956961fa50',
};
exports.mockLinkedinData = {
    success: true,
    certificateUri: 'https://www.linkedin.com/sharing/share-offsite/?url=https%3A%2F%2Fnba.com',
};
